import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const kanbanState = (state: RootState) => state.kanban;

const selectUserCurrentKanban = createSelector(
  kanbanState,
  (state) => state.kanban,
);

const selectUserKanbanLoading = createSelector(
  kanbanState,
  (state) => state.kanbanLoading,
);

const selectKanbansMeta = createSelector(
  kanbanState,
  (state) => state.kanbansMeta || [],
);

const selectKanbanCardById = createSelector(
  [kanbanState, (_, kanbanCardId: string) => kanbanCardId],
  (state, kanbanCardId) =>
    state.kanban?.columns
      ?.map((c) => c.cards)
      .flat()
      ?.find((card) => card?._id === kanbanCardId) || null,
);

export const kanbanSliceSelectors = {
  selectUserCurrentKanban,
  selectUserKanbanLoading,
  selectKanbansMeta,
  selectKanbanCardById,
};
